export function formatCoursePrice(price: number | null | undefined): string {
    return price == null ? 'Price not set' : new Intl.NumberFormat('en-GB', {
        style: 'currency', currency: 'GBP'
    }).format(price);
}
